import styled from "@emotion/styled";

import { MDSSelect } from "@/mds";

export const StyledChipWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const StyledSelect = styled(MDSSelect)<{ $isActive: boolean; $hasClearButton: boolean }>`
  button {
    background: ${({ $isActive, theme }) =>
      $isActive ? theme.colors.background.banner.emphasis : theme.colors.surface.pane};
    border: 1px solid
      ${({ $isActive, theme }) =>
        $isActive ? theme.colors.border.emphasis : theme.colors.border.default};
    border-radius: 999px;
    color: ${({ $isActive, theme }) =>
      $isActive ? theme.colors.text.emphasis : theme.colors.text.primary};
    height: 32px;
    min-width: 110px;
    padding: 0
      ${({ $hasClearButton, theme }) => ($hasClearButton ? theme.spacing[8] : theme.spacing[3])} 0
      ${({ theme }) => theme.spacing[3]};
    transition: none;

    &[data-hovered] {
      transition: none;
    }
  }

  [data-test-id="select-toggle-icon"] {
    display: ${({ $isActive }) => ($isActive ? "none" : "inline-flex")};
  }
`;

export const StyledTriggerContent = styled.span`
  align-items: center;
  display: inline-flex;
  gap: ${({ theme }) => theme.spacing[1]};
  min-width: 0;
`;

export const StyledTriggerLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledClearButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 999px;
  color: ${({ theme }) => theme.colors.text.emphasis};
  cursor: pointer;
  display: inline-flex;
  height: 20px;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: ${({ theme }) => theme.spacing[2]};
  top: 50%;
  transform: translateY(-50%);
  width: 20px;

  &:hover {
    background: ${({ theme }) => theme.colors.background.hoverOverlay.emphasis};
  }
`;
